import { render, staticRenderFns } from "./SummaryTreatmentComposition.vue?vue&type=template&id=392bebe3&scoped=true"
import script from "./SummaryTreatmentComposition.vue?vue&type=script&lang=js"
export * from "./SummaryTreatmentComposition.vue?vue&type=script&lang=js"
import style0 from "./SummaryTreatmentComposition.vue?vue&type=style&index=0&id=392bebe3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392bebe3",
  null
  
)

export default component.exports